import { combineReducers } from "redux";
import hobbyReducer from "./hobbyReducer";
import addCheckDate from "./CheckDateReducers";
import blankLatLngReducer from "./CheckDateReducers";
import roomDataReducer from "./RoomDataReducer";
const rootReducer = combineReducers({
  checkDate: addCheckDate,
  blankatLng: blankLatLngReducer,
  roomData: roomDataReducer,
});
export default rootReducer;
